import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Question } from "@/interfaces/questions";
import dataService from "@/endpoints/dataService";

export const fetchQuestion = createAsyncThunk<
  Question[],
  { userId: number },
  { rejectValue: string }
>("questions/fetchQuestionsList", async ({ userId }, thunkAPI) => {
  try {
    const response: Question[] = (await dataService.questions.getQuestionsList(
      userId
    )) as any;
    return response;
  } catch (err: any) {
    return thunkAPI.rejectWithValue("Fetch filters failed " + err.message);
  }
});

export const updateQuestionOptionColor = createAsyncThunk<
  { entityId: number; color: string; entityType: "QUESTION_OPTION" | "ROLLUP" } | null,
  { questionGroup: string; entityId: number; color: string; entityType: "QUESTION_OPTION" | "ROLLUP" },
  { rejectValue: string }
>(
  "questions/updateQuestionOptionColor",
  async ({ questionGroup, entityId, color, entityType }, thunkAPI) => {
    try {
      const response: any =
        await dataService.questions.updateQuestionOptionColor(
          questionGroup,
          entityId,
          color,
          entityType
        );
      if (response) {
        return {
          entityId,
          color,
          entityType,
        };
      }
      return null;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(
        "Failed to update question option color" + err.message
      );
    }
  }
);

export const createRollup = createAsyncThunk<any, any, { rejectValue: string }>(
  "questions/createRollup",
  async ({ payload, userId }, thunkAPI) => {
    try {
      const response: any = (await dataService.questions.createRollup(
        payload
      )) as any;
      await fetchQuestion({ userId });
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue("Failed to create rollup" + err.message);
    }
  }
);
